import { styled } from "@/styled-system/jsx";
import Link from "next/link";

export const NavBar = styled("nav", {
  base: {
    background: "linear-gradient(45deg, var(--color-primary) 0%, var(--color-primary-accent) 100%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    width: "100%",
    transition: "background 0.4s ease, padding 0.3s ease, background-position 0.4s ease",
    backgroundSize: "200% 200%",
    backgroundPosition: "0% 50%",
    boxShadow: "0px 4px 8px rgba(85, 79, 79, 0.2)",
    userSelect: "none",
    _mobile: {
      padding: "0px",
      paddingBottom: "10px",
    },
  },
});

export const NavContainer = styled("div", {
  base: {
    margin: "0 auto",
    maxWidth: "var(--navbar-footer-max-width)",
    padding: "var(--content-padding)",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "15px",
    paddingTop: "10px",
    paddingBottom: "10px",
    _mobile: {
      gap: "8px",
      flexDirection: "column",
    },
  },
});

export const NavLogoContainer = styled("div", {
  base: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    fontWeight: "900",
    fontSize: "35px",
    color: "white",
    whiteSpace: "nowrap",
  },
});

export const NavBarLinkContainer = styled("div", {
  base: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "20px",
    flexWrap: "wrap",
    width: "100%",
    _mobile: {
      gap: "8px",
      justifyContent: "center",
    },
  },
});

const navLinkStyles = {
  textDecoration: "none",
  padding: "10px 20px",
  border: "2px solid transparent",
  borderRadius: "var(--border-radius-medium)",
  fontWeight: "700",
  fontSize: "clamp(1rem, 1vw + 0.5rem, 1.1rem)",
  color: "#fff",
  textTransform: "uppercase",
  transition: "color 0.2s, background-color 0.3s, transform 0.2s",
  cursor: "pointer",
  minWidth: "150px",
  textAlign: "center",
  background: "transparent",
  _hover: {
    color: "var(--color-text)",
    backgroundColor: "#fff",
    transform: "scale(1.05)",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
  },
  _active: { transform: "scale(0.95)" },
} as const;

export const NavLinkItem = styled(Link, {
  base: { ...navLinkStyles },
});

export const NavLinkButton = styled("button", {
  base: { ...navLinkStyles },
});
